import { useRef } from 'react';
import { hasAutoActionsEditPermission } from './AutoActions.utils';

export const useIsReadOnlyAutoActions = (): boolean => {
    const isReadOnly = useRef<boolean>(!hasAutoActionsEditPermission());
    return isReadOnly.current;
};
